import * as THREE from 'THREE';
import THREEService from 'services/three-js-service';

const Vector3 = {
  up: new THREE.Vector3(0, 1, 0)
};

function Junction(type, name, position, normal, angle) {
  this._type = type;
  this._name = name;
  this._position = position;
  this._normal = normal.clone().normalize();
  this._angle = angle;

  this._parentComponent = null;
  this._childComponent = null;
}

Junction.createFromJson = function createFromJson(json) {
  const p = json.position;
  const n = json.normal;

  return new Junction(json.type, json.name,
    new THREE.Vector3(p.x, p.y, p.z), new THREE.Vector3(n.x, n.y, n.z),
    THREEService.degreeToRadian(json.angle));
};

Junction.prototype = {
  get type() {
    return this._type;
  },

  get name() {
    return this._name;
  },

  get position() {
    return this._position;
  },

  get normal() {
    return this._normal;
  },

  get angle() {
    return this._angle;
  },

  get parentComponent() {
    return this._parentComponent;
  },

  set parentComponent(value) {
    this._parentComponent = value;
  },

  get childComponent() {
    return this._childComponent;
  }
};

/**
 * Connect a child component to the junction.
 *
 * @param {Component} component
 * @returns {Promise}
 */
Junction.prototype.connect = function connect(component) {
  if (component.type !== this.type) {
    return Promise.reject('Unmatched type');
  }

  return this.disconnect().then(() => {
    if (!component || !this._parentComponent) {
      return Promise.reject('Component invalid');
    }

    return Promise.all([
      this._parentComponent.getModel(),
      component.getModel()
    ]);
  }).then((models) => {
    const parentModel = models[0];
    const childModel = models[1];

    // Note that the normal of the plane of the junction to be connected to
    // the parent component should be 0, 1, 0.
    childModel.quaternion.setFromUnitVectors(Vector3.up, this._normal);
    childModel.rotateOnAxis(Vector3.up, this._angle);

    childModel.position.copy(this._position);

    parentModel.add(childModel);
    this._childComponent = component;
  });
};

/**
 * Disconnect the child component from the junction.
 *
 * @returns {Promise}
 */
Junction.prototype.disconnect = function disconnect() {
  if (!this._childComponent || !this._parentComponent) {
    return Promise.resolve();
  }

  return Promise.all([
    this._parentComponent.getModel(),
    this._childComponent.getModel()
  ]).then((models) => {
    const parentModel = models[0];
    const childModel = models[1];

    parentModel.remove(childModel);
    this._childComponent = null;
  });
};

export default Junction;



// WEBPACK FOOTER //
// ./src/modules/junction.js